import { AxiosInstance } from './auth/AxiosInstance';

export const createReview = async (reviewData) => {
  const response = await AxiosInstance.post('/reviews', reviewData);
  return response.data;
};

export const getGigReviews = async (gigId, params = {}) => {
  const response = await AxiosInstance.get(`/reviews/gig/${gigId}`, { params });
  return response.data;
};

export const respondToReview = async (reviewId, comment) => {
  const response = await AxiosInstance.post(`/reviews/${reviewId}/respond`, { comment });
  return response.data;
};
